import React, { useState, useEffect } from 'react';
import api from '../api';

const AddToListModal = ({ isOpen, onClose, talentIds, onAdded }) => {
  const [lists, setLists] = useState([]);
  const [selectedListId, setSelectedListId] = useState('');
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    if (isOpen) {
      api.get('/talent-lists').then(r => setLists(r.data.lists || [])).catch(() => {});
    }
  }, [isOpen]);

  const handleAdd = async () => {
    let listId = selectedListId;

    if (creating) {
      if (!newName.trim()) return;
      try {
        const res = await api.post('/talent-lists', { name: newName.trim() });
        listId = res.data.list.id;
      } catch (e) { alert('Failed to create list'); return; }
    }

    if (!listId) return;
    setAdding(true);
    try {
      const res = await api.post(`/talent-lists/${listId}/items`, { talent_ids: talentIds });
      onAdded(listId, res.data.added);
      onClose();
    } catch (e) {
      alert('Failed to add to list');
    } finally { setAdding(false); }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl w-full max-w-sm p-6" onClick={e => e.stopPropagation()}>
        <h2 className="text-lg font-bold text-white mb-1">Add to Talent List</h2>
        <p className="text-zinc-400 text-sm mb-4">{talentIds.length} creator{talentIds.length !== 1 ? 's' : ''} selected</p>

        {!creating ? (
          <div className="space-y-3">
            <select value={selectedListId} onChange={e => setSelectedListId(e.target.value)}
              className="w-full bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 text-white text-sm">
              <option value="">Select a list...</option>
              {lists.map(l => <option key={l.id} value={l.id}>{l.name} ({l.item_count || 0})</option>)}
            </select>
            <button onClick={() => setCreating(true)} className="text-nextide-turquoise text-sm hover:underline">
              + Create new list
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            <input type="text" value={newName} onChange={e => setNewName(e.target.value)}
              placeholder="New list name..." autoFocus
              className="w-full bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 text-white text-sm" />
            <button onClick={() => { setCreating(false); setNewName(''); }} className="text-zinc-400 text-sm hover:underline">
              Back to existing lists
            </button>
          </div>
        )}

        <div className="flex gap-3 mt-5">
          <button onClick={onClose} className="flex-1 bg-zinc-800 text-white px-4 py-2 rounded-lg text-sm">Cancel</button>
          <button onClick={handleAdd}
            disabled={adding || (!creating && !selectedListId) || (creating && !newName.trim())}
            className="flex-1 bg-nextide-turquoise text-black px-4 py-2 rounded-lg text-sm font-semibold disabled:opacity-50">
            {adding ? 'Adding...' : 'Add to List'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToListModal;
